'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _themeSections = require('@shopify/theme-sections');

require('../../styles/components/_article-header.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-env browser */

var ArticleHeader = function () {
  function ArticleHeader() {
    (0, _classCallCheck3.default)(this, ArticleHeader);

    this.shareAction();
    // this.scrollCategories(); WIP
  }

  (0, _createClass3.default)(ArticleHeader, [{
    key: 'shareAction',
    value: function shareAction() {
      var _this = this;

      var shareButton = document.querySelector('[data-share-article]');

      if (shareButton) {
        var shareMessage = shareButton.getAttribute('data-share-article');

        // eslint-disable-next-line no-unused-vars
        shareButton.addEventListener('click', function (event) {
          var title = document.querySelector('[data-article-title]').textContent;
          var url = document.URL;

          if (navigator.share) {
            navigator.share({
              title: title,
              url: url
            }).catch(console.error);
          } else {
            _this.showNotification(shareMessage, 3000);
            _this.copyToClipBoard(url);
          }
        });
      }
    }
  }, {
    key: 'showNotification',
    value: function showNotification(message, duration) {

      var notificationDialog = document.querySelector('[data-notification-blog]');
      var notiticationMsg = document.querySelector('[data-notification-msg]');
      var notiticationClose = document.querySelector('[data-notification-close]');

      notificationDialog.classList.add('notifications--visible');

      notiticationMsg.innerHTML = message;

      notiticationClose.addEventListener('click', function () {
        notificationDialog.classList.remove('notifications--visible');
      });

      if (duration && duration > 0) {
        setTimeout(function () {
          notificationDialog.classList.remove('notifications--visible');
        }, duration);
      }
    }
  }, {
    key: 'copyToClipBoard',
    value: function copyToClipBoard(element) {
      var textToCopy = element;
      var myTemporaryInputElement = document.createElement('input');

      myTemporaryInputElement.type = 'text';
      myTemporaryInputElement.value = textToCopy;
      document.body.appendChild(myTemporaryInputElement);
      myTemporaryInputElement.select();
      document.execCommand('Copy');
      document.body.removeChild(myTemporaryInputElement);
    }
  }, {
    key: 'scrollCategories',
    value: function scrollCategories() {
      var lastScrollTop = 0;

      var templateArticle = document.querySelector('.template-article');

      if (templateArticle) {
        window.addEventListener('scroll', function () {
          var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
          var blogCategories = document.querySelector('[data-blog-categories]');
          var blogCategoriesTop = blogCategories.getBoundingClientRect().top;

          if (scrollPosition > lastScrollTop) {
            // down
            blogCategories.classList.add('sticky');
            blogCategories.classList.remove('is-visible');
          } else {
            // up
            blogCategories.classList.add('is-visible');

            if (scrollPosition <= blogCategoriesTop) {
              blogCategories.classList.remove('sticky');
              blogCategories.classList.remove('is-visible');
            }
          }

          // For Mobile or negative scrolling
          lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition;
        });
      }
    }
  }]);
  return ArticleHeader;
}();

new ArticleHeader();